import { watchEffect, type Directive, type WatchStopHandle } from 'vue'
import { useFeatureFlagsStore } from '@/store/featureFlags'

// Directiva `v-feature`: oculta el elemento si el flag está inactivo.
// Reacciona a cambios del store sin recargar la página.
//   <button v-feature="'ai_mode'">Abrir asistente IA</button>

interface FeatureBinding {
  stop: WatchStopHandle
  key: string
  originalDisplay: string
}

const registry = new WeakMap<HTMLElement, FeatureBinding>()

const featureDirective: Directive<HTMLElement, string> = {
  mounted(el, binding) {
    const store = useFeatureFlagsStore()
    const state: FeatureBinding = {
      key: binding.value,
      originalDisplay: el.style.display,
      stop: () => undefined,
    }
    state.stop = watchEffect(() => {
      el.style.display = store.isEnabled(state.key)
        ? state.originalDisplay
        : 'none'
    })
    registry.set(el, state)
  },
  updated(el, binding) {
    const state = registry.get(el)
    if (!state || state.key === binding.value) return
    state.key = binding.value
    const store = useFeatureFlagsStore()
    el.style.display = store.isEnabled(state.key)
      ? state.originalDisplay
      : 'none'
  },
  unmounted(el) {
    registry.get(el)?.stop()
    registry.delete(el)
  },
}

export default featureDirective
